(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/after-signup-message.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/after-signup-message.js'); 'use strict';

svs.competition.core.afterSignupMessage = function (type, competition, regCloseTime) {
  if (svs.utils.ns.isNamespace('svs.competition.core.data.tipsSMCompetition')) {
    var dialogConfig = {
      branding: svs.components.dialog.branding.SPORT,
      icon: 'nav-games',
      title: "Du \xE4r anm\xE4ld till ".concat(svs.competition.core.makeup(competition.compDesc), "!"),
      actions: [{
        title: 'OK'
      }]
    };

    switch (type) {
      case 'can_play':
        dialogConfig.message = [{
          type: svs.components.dialog.message.TEXT,
          text: 'Vill du lägga ditt första spel nu?'
        }];
        dialogConfig.actions = [{
          title: 'Inte nu'
        }, {
          title: 'Lägg spel',
          callback: function callback() {
            svs.components.dialog.api.close();
            var redirectUrl = '';

            switch (competition.tipsSMDetails.productId) {
              case 'STRYK':
                redirectUrl = svs.utils.urlMapping.get('stryktipsetHome');
                break;

              case 'ITA':
                redirectUrl = svs.utils.urlMapping.get('europatipsetHome');
                break;

              default:
            }

            window.location.href = "".concat(redirectUrl, "/tipssm/spela");
          }
        }];
        break;

      case 'can_not_play':
        {
          dialogConfig.message = [{
            type: svs.components.dialog.message.TEXT,
            text: "F\xF6rsta omg\xE5ngen i t\xE4vlingen har spelstopp ".concat(svs.utils.date.ShortDateAndTime(regCloseTime), " s\xE5 kom ih\xE5g att l\xE4gga ditt spel. Lycka till!")
          }];
          break;
        }

      case 'can_not_play_date':
        {
          var date = moment(competition.tipsSMDetails.startTime).format('DD MMMM');
          dialogConfig.message = [{
            type: svs.components.dialog.message.TEXT,
            text: "F\xF6rsta omg\xE5ngen i t\xE4vlingen har spelstopp ".concat(date, " s\xE5 kom ih\xE5g att l\xE4gga ditt spel. Lycka till!")
          }];
          break;
        }

      default:
    }

    svs.components.dialog.api.add(new svs.components.dialog.Confirm(dialogConfig));
  }
};
 })(window);